// Used through the app to enable icon choice auto-completion
// and thus reduce typo

// PROPERTIES
// ---- System icons
export const kSystemIcons = {
    about: "history_edu",
    arrowDown: "arrow_downward",
    arrowDouble: "unfold_less",
    arrowUp: "arrow_upward",
    account: "account_circle",
    balance: "account_balance",
    assignment: "assignment",
    brain: "network_intel_node",
    bolt: "bolt",
    book: "menu_book",
    cancel: "cancel",
    calculation: "calculate",
    category: "category",
    check: "check",
    chevronLeft: "chevron_left",
    chevronRight: "chevron_right",
    close: 'close',
    collapse: "menu_open",
    convention: "assignment",
    dictionary: "book",
    download: "file_download",
    erase: "backspace",
    error: "error",
    eye: "visibility",
    eye_off: "visibility_off",
    exam: "description",
    exit: 'exit_to_app',
    filter: "filter_list",
    flare: "flare",
    function: "functions",
    games: "gamepad",
    gear: "settings",
    heart: "favorite",
    help: 'help',
    key: "key",
    level: "school",
    lock: "lock",
    logout: "logout",
    medal: "military_tech",
    menu: "menu",
    more: "more_horiz",
    play: "play_arrow",
    property: "gavel",
    psychology: "psychology",
    question: "question_mark",
    school: "school",
    search: "search",
    smartphone: "smartphone",
    star: "star",
    steps: "more_vert",
    subtheme: "category",
    support: "support",
    task: "adjust",
    timer: "timer",
    title: "title",
    theme: "bookmarks",
    token: 'widgets',
    trophy: "emoji_events",
    userId: "assignment_ind",
    video: "ondemand_video",
    waves: "waves",
    zoomIn: "zoom_in"
}